import { Play, Video } from 'lucide-react'
import { useState } from 'react'
import { useVideos } from '@/hooks/useVideos'
import type { Video as VideoType } from '@/types'

export default function KanalVideo() {
  const { videos, loading } = useVideos()
  const [selected, setSelected] = useState<VideoType | null>(null)

  return (
    <div className="p-6">
      <h1 className="text-xl font-bold text-gray-800 dark:text-white mb-1">Kanal Video CERAH</h1>
      <p className="text-sm text-gray-400 mb-6">Video penjelasan dari Direktur dan Management CERAH</p>

      {/* Video player modal */}
      {selected && (
        <div className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center p-4" onClick={() => setSelected(null)}>
          <div className="bg-white dark:bg-gray-900 rounded-2xl overflow-hidden w-full max-w-3xl shadow-2xl" onClick={e => e.stopPropagation()}>
            <div className="aspect-video w-full bg-black">
              <iframe
                src={selected.iframe_url}
                title={selected.title}
                className="w-full h-full"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
            <div className="p-5">
              <p className="font-semibold text-gray-800 dark:text-white">{selected.title}</p>
              {selected.speaker_name && (
                <p className="text-sm text-cerah-teal mt-1">{selected.speaker_name} — {selected.speaker_title}</p>
              )}
              {selected.description && (
                <p className="text-sm text-gray-500 mt-2 leading-relaxed">{selected.description}</p>
              )}
              <button onClick={() => setSelected(null)} className="mt-4 text-sm text-gray-400 hover:text-gray-600">Tutup</button>
            </div>
          </div>
        </div>
      )}

      {loading ? (
        <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4">
          {[...Array(8)].map((_, i) => <div key={i} className="aspect-video bg-gray-100 dark:bg-gray-800 rounded-xl animate-pulse" />)}
        </div>
      ) : videos.length === 0 ? (
        <div className="flex flex-col items-center py-20 text-center">
          <Video size={40} className="text-gray-300 dark:text-gray-600 mb-3" />
          <p className="text-sm text-gray-500">Belum ada video yang ditambahkan.</p>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4">
          {videos.map(v => (
            <button key={v.id} onClick={() => setSelected(v)} className="text-left rounded-xl overflow-hidden bg-white dark:bg-gray-800 border border-gray-100 dark:border-gray-700 shadow-sm hover:shadow-md hover:border-cerah-teal/30 transition-all">
              <div className="relative aspect-video bg-gray-100 dark:bg-gray-700">
                {v.thumbnail_url
                  ? <img src={v.thumbnail_url} alt={v.title} className="w-full h-full object-cover" />
                  : <div className="w-full h-full flex items-center justify-center"><Video size={28} className="text-gray-300" /></div>
                }
                <div className="absolute inset-0 flex items-center justify-center bg-black/10 hover:bg-black/20 transition-colors">
                  <div className="w-12 h-12 bg-white/90 rounded-full flex items-center justify-center shadow">
                    <Play size={18} className="text-cerah-teal fill-cerah-teal ml-0.5" />
                  </div>
                </div>
                {v.duration && (
                  <span className="absolute bottom-2 right-2 bg-black/70 text-white text-[10px] px-1.5 py-0.5 rounded font-mono">{v.duration}</span>
                )}
              </div>
              <div className="p-3">
                <p className="text-xs font-semibold text-cerah-teal truncate">{v.speaker_name}</p>
                <p className="text-xs text-gray-500 truncate">{v.speaker_title}</p>
                <p className="text-xs font-medium text-gray-700 dark:text-gray-300 mt-1 line-clamp-2">{v.title}</p>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
